/**
 * FAQ Toggle
 *
 * @since   1.0.0
 * @package uma
 */

(function($) {

	$('.faq').click(function() {
	    $(this).toggleClass('on');
	});

}(jQuery));